import React from 'react';
import { Table, LoadingSpinner } from 'edenred-ui';
import { CardOrdersTableProps } from '@epi-models/pages/Reports';
import { CardOrdersTableHead } from './CardOrdersTableHead';
import { CardOrdersTableBody } from './CardOrdersTableBody';
import { TableNoContent } from '../../TableNoContent';

export const CardOrdersTable = ({
  ordersHistory,
  isLoading
}: CardOrdersTableProps) => {
  if (isLoading) return <LoadingSpinner />;

  return (
    <Table>
      <Table.Head>
        <CardOrdersTableHead />
      </Table.Head>
      <Table.Body>
        {ordersHistory.length ? (
          <CardOrdersTableBody ordersHistory={ordersHistory} />
        ) : (
          <TableNoContent colSpan={5} />
        )}
      </Table.Body>
    </Table>
  );
};
